import { Component, Prop, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class AccordionHeader extends ThemeComponent {
    @Prop({ default: false }) open!: boolean;

    private _onOpenChange = new SimpleEvent<boolean>();

    public get onOpenChange() {
        return this._onOpenChange.asEvent();
    }

    public changeOpen(open: boolean) {
        this.open = open;

        // Use the private backing field to dispatch
        this._onOpenChange.dispatch(open);
    }

    init() {
        this.$listen(this, 'click', () => {
            this._onOpenChange.dispatch(this.open);
        });
    }
}
